import React, { FC, useEffect, useMemo, useState } from 'react'
import "../../styles/homePage/table/tableHeader.scss"
import { useTranslation } from 'react-i18next'
import TableHeaderCards from './TableHeaderCards'
import { TableCard, TableHeaderTabs } from '../../common/types/tableCardType'
import { ReactComponent as Arrow } from '../../common/assats/homeScreens/cardsIcons/arrow.svg';

export interface TableHeaderParams {
    headerHeadline?: string
    totalCount?: number
    cards: TableCard[]
    viewAllAction?: () => void,
    tabs?: TableHeaderTabs[],
    tableHeaderTitle?: string,
    customContainerClass?: string,
    defaultActiveKey?: string,

};



const TableHeader: FC<TableHeaderParams> = ({
    headerHeadline,
    cards,
    totalCount,
    viewAllAction,
    tabs,
    tableHeaderTitle,
    customContainerClass,
    defaultActiveKey,

 }) => {

    const { t } = useTranslation()


    return (

        <div className={`table-header-main-container ${customContainerClass}`}>
            {headerHeadline ?
                <div className={`table-status-headline ${!totalCount ? 'flex-start' : ''}`}>
                    <div className='main-headline-container'>
                        <label className='main-headline heading-h2'>{headerHeadline}</label>
                    </div>
                    {totalCount ?
                        <div className='second-headline-container'>
                            <label className='total-text heading-h4'>{t("table.header.total") + " " + headerHeadline.replace(" Status", "") + " - " + totalCount}</label>
                            <p className='view-all-text' onClick={viewAllAction}>{t("table.header.viewAll")} <Arrow /></p>

                        </div> : null
                    }

                </div> : null
            }
            <div className='patients-cards'>
                <TableHeaderCards cards={cards} tabs={tabs} tableHeaderTitle={tableHeaderTitle} defaultActiveKey={defaultActiveKey} />
            </div>
        </div>
    )
}

export default TableHeader